import React, { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Box,
  Divider,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { authTokenState } from 'features/auth/state/authAtoms';
import { selectedCFDState, taskArnMapState, CFDStatus } from 'features/cfd/state/cfdAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { CustomButton } from 'shared/ui/CustomButton';
import { fetchZipFromS3 } from 'features/cfd/api/fetchZipFromS3';

const subtitleSx = {
  display: 'flex',
  alignItems: 'center',
};

// 保存名に角度（0° / 4°）を入れ、手元でどちらのケースか分かるようにする
const angleOf = (objectiveKey: string) =>
  objectiveKey.endsWith('4deg') ? '4deg' : '0deg';

// cid → 保存名。Cd & Cl は同じケースの 2 値で同じ ID が複数キーに入るため、
// ID で重複を除く（除かないと同じ zip を 2 回要求し、zip 化タスクも重複起動し得る）
const downloadTargets = (cfd: CFDStatus) => {
  const targets = new Map<string, string>();
  Object.entries(cfd.cfd_id || {}).forEach(([key, cid]) => {
    if (cid && !targets.has(cid)) {
      targets.set(cid, `${cfd.name}_${angleOf(key)}.zip`);
    }
  });
  return targets;
};

export const CFDDownload: React.FC = () => {
  const authToken = useRecoilValue(authTokenState);
  const selectedCFD = useRecoilValue(selectedCFDState);
  const [taskArnMap, setTaskArnMap] = useRecoilState(taskArnMapState);
  const [apiLoading, setApiLoading] = useState<boolean>(false);

  const handleClick = async () => {
    setApiLoading(true);
    if (authToken !== '') {
      if (selectedCFD) {
        if (selectedCFD.status_code !== 201) {
          downloadTargets(selectedCFD).forEach(async (fileName, cid) => {
            const taskArn = taskArnMap[cid];
            const arn = await fetchZipFromS3(authToken, cid, taskArn, fileName);
            setTaskArnMap((prev) => ({
              ...prev,
              [cid]: arn,
            }));
          });
        } else {
          alert("The specified CFD has not been completed and cannot be downloaded.");
        }
      }
    }
    setApiLoading(false);
  };

  return (
    <Box component="div" sx={{ boxSizing: 'border-box', flexGrow: 1, paddingTop: 1 }}>
      <Box component="div" sx={subtitleSx}>
        <CustomTypography >CFD Download</CustomTypography>
      </Box>

      <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box component="div" sx={{ width: '40%' }}>
        <CustomButton
          size='small'
          disabled={apiLoading}
          onClick={handleClick}
          loading={apiLoading}
          loadingPosition='start'
          startIcon={<DownloadIcon />}
          variant='contained'
          sx={{ fontSize: '10px', width: '100%' }}
        >
          Download
        </CustomButton>
      </Box >
    </Box>
  );
};
